<div class="pss-wrapper">

  <!-- Breadcrumb (alt gruplarda navigasyon) -->
  @if (navigasyonYolu().length > 0 && !seciliSet()) {
    <div class="pss-breadcrumb">
      <button class="pss-geri-btn" (click)="geriGit()">
        <i class="angle left icon"></i> Geri
      </button>
      <span class="pss-yol">
        @for (parca of breadcrumb(); track $index) {
          @if ($index > 0) { <span class="pss-yol-ayrac">/</span> }
          <span class="pss-yol-parca">{{ parca }}</span>
        }
      </span>
    </div>
  }

  <!-- Set aktifken: geri butonu -->
  @if (seciliSet()) {
    <div class="pss-breadcrumb">
      <button class="pss-geri-btn" (click)="secimKaldir()">
        <i class="angle left icon"></i> Geri
      </button>
      <span class="pss-yol">
        <span class="pss-yol-parca">{{ seciliSet()!.simge }} {{ seciliSet()!.baslik }}</span>
      </span>
    </div>
  }

  <!-- Arama Kutusu -->
  @if (!seciliSet()) {
    <div class="pss-arama">
      <nz-input-wrapper nzSize="small" [nzPrefix]="aramaIkon">
        <input nz-input
               placeholder="Bilesen ara..."
               [ngModel]="aramaMetni()"
               (ngModelChange)="aramaMetni.set($event)" />
      </nz-input-wrapper>
      <ng-template #aramaIkon><i class="search icon" style="opacity:.5;font-size:12px;"></i></ng-template>
    </div>
  }

  <!-- Tile Grid: Ust Gruplar -->
  @if (!aktifAltGruplar() && !seciliSet()) {
    @if (gosterilecekGruplar()?.length === 0 && aramaMetni()) {
      <div class="pss-bos-sonuc">
        <i class="search icon"></i>
        <span>"{{ aramaMetni() }}" icin sonuc bulunamadi</span>
      </div>
    }
    <div class="pss-tile-grid" [ngClass]="animSinifi">
      @for (grup of gosterilecekGruplar(); track grup.id; let i = $index) {
        <button class="pss-tile"
                [class.disabled]="!kullanilabilirMi(grup.yetkiler)"
                [class.secili]="seciliSetId === grup.id"
                [style.--tile-renk]="grup.renk || 'linear-gradient(135deg, #1e3a5f, #1677ff)'"
                [style.animation-delay.ms]="i * 40"
                (click)="grupTiklandi(grup)">
          <div class="pss-tile-ust">
            <span class="pss-tile-simge">{{ grup.simge }}</span>
          </div>
          <div class="pss-tile-alt">
            <span class="pss-tile-baslik">{{ grup.baslik }}</span>
            @if (grup.altGruplar?.length) {
              <span class="pss-tile-ok">&rarr;</span>
            }
          </div>
          @if (grup.aciklama) {
            <span class="pss-tile-aciklama">{{ grup.aciklama }}</span>
          }
          @if (seciliSetId === grup.id) {
            <span class="pss-tile-secili-badge">&#10003;</span>
          }
        </button>
      }
    </div>
  }

  <!-- Tile Grid: Alt Setler -->
  @if (aktifAltGruplar() && !seciliSet()) {
    @if (filtrelenmisAltGruplar()?.length === 0 && aramaMetni()) {
      <div class="pss-bos-sonuc">
        <i class="search icon"></i>
        <span>"{{ aramaMetni() }}" icin sonuc bulunamadi</span>
      </div>
    }
    <div class="pss-tile-grid" [ngClass]="animSinifi">
      @for (set of filtrelenmisAltGruplar(); track set.id; let i = $index) {
        <button class="pss-tile"
                [class.disabled]="!kullanilabilirMi(set.yetkiler)"
                [class.secili]="seciliSetId === set.id"
                [style.animation-delay.ms]="i * 40"
                (click)="altSetTiklandi(set)">
          <div class="pss-tile-ust">
            <span class="pss-tile-simge">{{ set.simge }}</span>
          </div>
          <div class="pss-tile-alt">
            <span class="pss-tile-baslik">{{ set.baslik }}</span>
          </div>
          @if (set.aciklama) {
            <span class="pss-tile-aciklama">{{ set.aciklama }}</span>
          }
          @if (seciliSetId === set.id) {
            <span class="pss-tile-secili-badge">&#10003;</span>
          }
        </button>
      }
    </div>
  }

</div>
